module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/food/pizza-37f371578590035c23f426fb57b8346f.svg";